<template>
  <div>
    <PageHeader
      image="header-5"
      withMobile
      :title="$lang('title')"
      :breadcrumbs="$lang('breadcr')"
    />
    <section class="py-7">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 text-center">
            <h2 class="mb-4 text-blue2">{{ $lang("subtitle") }}</h2>
            <p class="lead mb-5">{{ $lang("description") }}</p>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8">
            <div class="card shadow-lg border-0 mb-5">
              <div class="card-body p-5">
                <h3 class="card-title text-center mb-4 text-blue2">{{ $lang("form_title") }}</h3>

                <div role="main" id="english-test-a2466c70cd84c388381d"></div>

                <!-- Scoring System -->
                <div class="mt-5 pt-4 border-top">
                  <div class="d-flex align-items-center mb-4">
                    <i class="fas fa-chart-line text-blue2 fa-2x me-3"></i>
                    <h4 class="text-blue2 mb-0">English Level Assessment System</h4>
                  </div>

                  <div class="scoring-system p-4 mb-4">
                    <div class="text-center mb-4">
                      <h5 class="text-blue1 mb-3">
                        After completing the test, your English level will be assessed
                      </h5>
                      <p class="mb-0">
                        The test consists of 25 questions to evaluate your English proficiency
                      </p>
                    </div>

                    <div class="level-cards">
                      <div class="level-card beginner">
                        <div class="level-header">
                          <span class="score-badge">1-5</span>
                        </div>
                        <div class="level-name">Beginner / Pre-A1</div>
                      </div>

                      <div class="level-card elementary">
                        <div class="level-header">
                          <span class="score-badge">6-10</span>
                        </div>
                        <div class="level-name">Elementary</div>
                      </div>

                      <div class="level-card pre-intermediate">
                        <div class="level-header">
                          <span class="score-badge">11-14</span>
                        </div>
                        <div class="level-name">Pre-Intermediate</div>
                      </div>

                      <div class="level-card intermediate">
                        <div class="level-header">
                          <span class="score-badge">15-19</span>
                        </div>
                        <div class="level-name">Intermediate</div>
                      </div>

                      <div class="level-card upper-intermediate">
                        <div class="level-header">
                          <span class="score-badge">20-22</span>
                        </div>
                        <div class="level-name">Upper-Intermediate</div>
                      </div>

                      <div class="level-card advanced">
                        <div class="level-header">
                          <span class="score-badge">23-25</span>
                        </div>
                        <div class="level-name">Advanced</div>
                      </div>
                    </div>
                  </div>

                  <div class="disclaimer-box p-3">
                    <div class="d-flex">
                      <i class="fas fa-info-circle text-blue2 me-3 mt-1"></i>
                      <p class="disclaimer-text mb-0">
                        This level-assessment is indicative only. A full assessment of your English
                        language skills will be conducted as part of your induction process at NED
                        College and an appropriate level of study assigned to you.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";

export default {
  components: {
    PageHeader,
  },
  mounted() {
    // Load RD Station Forms script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js";
    script.onload = () => {
      // Initialize the form after script loads
      new window.RDStationForms('english-test-a2466c70cd84c388381d', 'null').createForm();
    };
    document.head.appendChild(script);
  },
};
</script>

<style scoped>
.form-control {
  border-radius: var(--radius-xs);
  padding: 0.85rem 1.2rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  color: #212529;
  height: auto;
  min-height: 3.5rem;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.form-control:focus {
  border-color: var(--blue2);
  box-shadow: 0 0 0 0.2rem rgba(0, 50, 255, 0.15);
  outline: 0;
}

select.form-control {
  color: #212529 !important;
  appearance: auto;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 8px 10px;
  padding-right: 2.5rem;
}

select.form-control option {
  color: #212529;
  padding: 0.5rem;
  font-size: 1rem;
}

.placeholder-option {
  color: #6c757d !important;
  font-style: italic;
}

.btn-primary {
  background: var(--blue-grad-2);
  border: none;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border-radius: var(--radius-xs);
  font-size: 0.875rem;
  color: var(--blue-grad-2-text);
}

.btn-primary:hover {
  background: var(--blue-grad-2-hover);
  border: none;
}

.card {
  border-radius: var(--radius-sm);
}

h2 {
  font-size: 1.75rem;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

p {
  font-size: 0.875rem;
}

label {
  font-size: 0.875rem;
}

.lead {
  font-size: 1.15rem;
  line-height: 1.6;
  font-weight: 400;
}

.scoring-system {
  background-color: rgba(0, 18, 76, 0.03);
  border-radius: var(--radius-sm);
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.level-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

.level-card {
  border-radius: var(--radius-xs);
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.level-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.level-header {
  padding: 12px 0;
  text-align: center;
}

.score-badge {
  display: inline-block;
  background-color: white;
  color: var(--blue1);
  font-weight: 700;
  font-size: 1.1rem;
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  min-width: 55px;
  text-align: center;
}

.level-name {
  background-color: white;
  color: var(--blue1);
  text-align: center;
  padding: 10px;
  font-weight: 600;
  font-size: 0.85rem;
}

.beginner .level-header {
  background: linear-gradient(45deg, #00124c, #0032ff);
}

.elementary .level-header {
  background: linear-gradient(45deg, #0032ff, #00c2ef);
}

.pre-intermediate .level-header {
  background: linear-gradient(45deg, #00c2ef, #3cdbc0);
}

.intermediate .level-header {
  background: linear-gradient(45deg, #3cdbc0, #9cffac);
}

.upper-intermediate .level-header {
  background: linear-gradient(45deg, #9cffac, #00a7b5);
}

.advanced .level-header {
  background: linear-gradient(45deg, #00a7b5, #00259e);
}

.disclaimer-box {
  background-color: rgba(0, 18, 76, 0.02);
  border-radius: var(--radius-xs);
  border-left: 3px solid var(--blue2);
}

.disclaimer-text {
  font-size: 0.85rem;
  color: var(--black2);
  line-height: 1.5;
}
</style>
